export const ActionType = {
    GET_MAP_START: "GET_MAP_START",
    GET_MAP_SUCCESS: "GET_MAP_SUCCESS",
    GET_MAP_ERROR: "GET_MAP_ERROR",
    SET_MAP_COORDS: "SET_MAP_COORDS",
    DELETE_MAP: "DELETE_MAP",
    SET_COLOR: "SET_COLOR",
    SET_DETAILS: "SET_DETAILS"
};
